(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const closeAll = (except) => {
      document.querySelectorAll('details[data-hw-dropdown][open]').forEach((el) => {
        if (el !== except) el.removeAttribute('open');
      });
    };

    document.addEventListener('click', (event) => {
      const inside = event.target.closest('details[data-hw-dropdown]');
      closeAll(inside);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = document.querySelector('details[data-hw-dropdown][open]');
      if (!open) return;
      open.removeAttribute('open');
      open.querySelector('summary')?.focus();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
